export const saveToSessionStorage = (key, data) => {
  if (data) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
};

export const getFromSessionStorage = (key) => {
  const storedData = sessionStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : null;
};

export const removeSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};
